const COMMON_FETCH_INGREDIENTS = {
  START: 'START_COMMON_FETCH_INGREDIENTS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_INGREDIENTS',
  FAIL: 'FAIL_COMMON_FETCH_INGREDIENTS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_INGREDIENTS',
}

export default COMMON_FETCH_INGREDIENTS
